import React from 'react';
import ErrorBoundary from './ErrorBoundary';

interface RouteErrorBoundaryProps {
  children: React.ReactNode;
  routeName?: string;
}

export const RouteErrorBoundary: React.FC<RouteErrorBoundaryProps> = ({ 
  children, 
  routeName = 'página' 
}) => {
  const handleReset = () => {
    console.log(`RouteErrorBoundary - Resetando ${routeName}`);
  };

  return (
    <ErrorBoundary onReset={handleReset}>
      {children}
    </ErrorBoundary>
  );
};

export const withRouteBoundary = <P extends object>(
  Component: React.ComponentType<P>,
  routeName?: string
) => {
  const WrappedComponent: React.FC<P> = (props) => (
    <RouteErrorBoundary routeName={routeName}>
      <Component {...props} />
    </RouteErrorBoundary>
  );

  WrappedComponent.displayName = `withRouteBoundary(${Component.displayName || Component.name})`;
  
  return WrappedComponent;
};
